// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__ItyAy","empty":"ModalGraph_empty__1ZpGw"};